import {invalidateQueries, q} from "../../state";
import {CreateTprmQuestionnaireModel, TprmQuestionnaireModel, TprmQuestionnaireModelId} from "platformed-client/types";
import {platformedClient} from "..";

/**
 * List all questionnaire models
 */
export async function list(): Promise<TprmQuestionnaireModel[]> {
  return await platformedClient.internalRequest("get", "/region/{region}/api/tprm/questionnaire_models", {});
}

/**
 * Get a specific questionnaire model by ID
 */
export async function get(questionnaireModelId: TprmQuestionnaireModelId): Promise<TprmQuestionnaireModel> {
  return await platformedClient.internalRequest(
    "get",
    "/region/{region}/api/tprm/questionnaire_models/{questionnaire_model_id}",
    {path: {questionnaire_model_id: questionnaireModelId}},
  );
}

/**
 * Create a new questionnaire model
 */
export async function create(model: CreateTprmQuestionnaireModel): Promise<TprmQuestionnaireModelId> {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/tprm/questionnaire_models", {
    body: model,
  });
  await invalidateQueries([q.tprm.questionnaireModels.filter()]);
  return res;
}

/**
 * Delete a questionnaire model and all its versions; refused with 409 while it is in use
 */
export async function delete_(questionnaireModelId: TprmQuestionnaireModelId): Promise<void> {
  await platformedClient.internalRequest(
    "delete",
    "/region/{region}/api/tprm/questionnaire_models/{questionnaire_model_id}",
    {path: {questionnaire_model_id: questionnaireModelId}},
  );
  await invalidateQueries([q.tprm.questionnaireModels.filter()]);
}
